import { container } from "tsyringe";
import toValidationError from "utils/toValidationError";
import ChoiceApi from "api/clapaction/projects/[id]/config/question/[id]/ChoiceApi";
import ChoiceRequestResource from "common/resources/Project/Config/Choice/ChoiceRequestResource";

export default class ChoiceService {
	private api: ChoiceApi = container.resolve(ChoiceApi);

	public async downloadImage(projectId: string, questionId: string, choiceId: string): Promise<Blob> {
		return this.api.downloadFile(projectId, questionId, choiceId).catch(toValidationError);
	}

	public async create(projectId: string, questionId: string, data: ChoiceRequestResource, file?: File): Promise<void> {
		return this.api.create(projectId, questionId, data, file).catch(toValidationError);
	}

	public async update(projectId: string, questionId: string, choiceId: string, data: ChoiceRequestResource, file?: File): Promise<void> {
		return this.api.update(projectId, questionId, choiceId, data, file).catch(toValidationError);
	}

	public async delete(projectId: string, questionId: string, choiceId: string): Promise<void> {
		return this.api.delete(projectId, questionId, choiceId).catch(toValidationError);
	}
}
